import { useNavigate } from "react-router-dom";
import { useSignalR } from "./SignalRContext";
import PropTypes from "prop-types";
import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useMemo,
} from "react";

const NotificationContext = createContext();

export function useNotificationContext() {
  return useContext(NotificationContext);
}

export function NotificationProvider(props) {

  const [notifsCopy, setNotifsCopy] = useState([]); //reference from previous notifs
  const navigate = useNavigate();

  const { notifications } = useSignalR();

  useEffect(() => {
    setNotifsCopy(notifications);
  }, []);

  useEffect(() => {
    //if there's incoming notif, set new notifs reference
    if (notifications.length >= notifsCopy.length) {
      setNotifsCopy(notifications);
    }
  }, [notifications]);

  const data = useMemo(
    () => ({
      setNotifsCopy,
      navigate,
      notifsCopy
    }),
    [notifsCopy]
  );

  return (
    <NotificationContext.Provider value={data}>
      {props.children}
    </NotificationContext.Provider>
  );
}

NotificationProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
